import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, EMPTY } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { UsersService } from "src/app/admin/users/users.service";
import { AuthService, IAuthToken } from "src/app/shared/services/auth.service";
import { CurrentUserService } from "src/app/shared/services/current-user.service";
import { MustMatch } from "src/app/shared/validators/must-match.validator";

@Component({
  selector: "app-confirm-email",
  templateUrl: "./confirm-email.component.html",
  styleUrls: ["./confirm-email.component.scss"],
})
export class ConfirmEmailComponent implements OnInit {
  private savingSubject = new BehaviorSubject<boolean>(false);
  saving$ = this.savingSubject.asObservable();

  email: string = null;
  authToken: IAuthToken = null;
  emailConfirmed = false;

  changePasswordForm: FormGroup;
  failedSubmitAttempt = false;
  submissionErrors: string[] = [];

  get newPasswordControl() {
    return this.changePasswordForm.controls.newPassword;
  }
  get newPasswordConfirmControl() {
    return this.changePasswordForm.controls.newPasswordConfirm;
  }

  constructor(
    private route: ActivatedRoute,
    private userService: UsersService,
    private currentUserService: CurrentUserService,
    private authService: AuthService,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParams["token"];
    const email = this.route.snapshot.queryParams["email"];

    // TODO some error stuff here so someone cant just navigate here without token or email
    this.email = email;

    this.userService.confirmEmail(email, token).subscribe((token) => {
      this.emailConfirmed = true;
      this.authToken = token;
    });
    this.buildForm();
  }
  buildForm() {
    this.changePasswordForm = this.fb.group(
      {
        newPassword: [
          "",
          Validators.compose([Validators.required, Validators.minLength(6)]),
        ],
        newPasswordConfirm: ["", Validators.required],
      },
      { validators: [MustMatch("newPassword", "newPasswordConfirm")] }
    );
  }
  submit() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
    this.savingSubject.next(true);
    const userId = this.authService.getUserIdFromToken(this.authToken.token);
    this.userService
      .setUserPassword(userId, this.changePasswordForm.value, this.authToken)
      .pipe(
        catchError((e) => {
          this.failedSubmitAttempt = true;
          this.submissionErrors = this.getErrors(e);
          this.changePasswordForm.markAsUntouched();
          return EMPTY;
        }),
        finalize(() => {
          this.savingSubject.next(false);
        })
      )
      .subscribe((r) => {
        // dont log the user in until they set password
        this.authService.loginForUser(this.authToken);
        // TODO Toast!
        this.router.navigate(["/timetracking"]);
      });
  }
  private getErrors(e): string[] {
    if (Array.isArray(e.error)) {
      return e.error
    }
  return [e.error]
  }
}
